import { toast } from 'react-toastify';

const ToastWarning = (text, id, timeOpen = 5000) => {
  let status = true;
  if (toast.isActive(id)) {
    status = false;
  }
  if (status) {
    return (
      toast.warning(text, {
        toastId: id,
        position: "top-right",
        autoClose: timeOpen,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          top: '100px'
        }
      })
    )
  }
}

export default ToastWarning;